import { BlocksIconNotificationsFilled } from 'blocks-nextjs/blocks-web-components/components/icon/icons/notifications-filled';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconNotificationsFilled = createComponent({
  react: React,
  tagName: 'cat-icon-notifications-filled',
  elementClass: BlocksIconNotificationsFilled
});
